import React, { Component } from "react";

import Dropdown from "./dropdown";
import SearchPanel from "./searchPanel";
import ModalToggler from "../modalToggler";

import CSVUtils from "../../utils/csvUtil";
import HTMLUtil from "../../utils/htmlUtil";
import ReactGA from "react-ga4";

const PREFIX_API = HTMLUtil.getPrefixAPI();

const LOCALES = {
  title: {
    label: {
      fr: "Recherche",
      en: "Search",
    },
  },
  note: {
    "modal-title": {
      fr: "",
      en: "",
    },
    label: {
      fr: "Note importante sur les importations du Québec",
      en: "Important notice on Quebec imports",
    },
  },
  description: {
    label: {
      fr: "Commencez par faire votre choix dans les options ci-dessous. Pour afficher les données appuyer sur le bouton <b>Produire rapport</b>.",
      en: "Begin by making your selection in the options below. To view the data press the <b>Run report</b> button.",
    },
  },
  "trade-type": {
    label: {
      fr: "Type d'échange",
      en: "Trade type",
    },
  },
  "time-period": {
    label: {
      fr: "Période",
      en: "Time period",
    },
  },
  "custom-years": {
    label: {
      fr: "Choisir une ou plusieurs années",
      en: "Select one or more years",
    },
  },
  trader: {
    label: {
      fr: "Commerçant",
      en: "Trader",
    },
  },
  partner: {
    label: {
      fr: "Partenaire commercial",
      en: "Trading partner",
    },
  },
  "partner-list": {
    label: {
      sp: {
        fr: "Choisir au moins un pays",
        en: "Select at least one country",
      },
      re: {
        fr: "Choisir au moins un état",
        en: "Select at least one state",
      },
      gpc: {
        fr: "Choisir au moins un groupe de partenaires commerciaux",
        en: "Select at least one group of business partners",
      },
      reur: {
        fr: "Choisir au moins une région",
        en: "Select at least one area",
      },
    },
  },
  currency: {
    label: {
      fr: "Valeur",
      en: "Value",
    },
  },
  "search-type": {
    label: {
      sh: {
        fr: "Recherche par produit",
        en: "Product Search",
      },
      scian: {
        fr: "Recherche par industrie",
        en: "Industry Search",
      },
      cti: {
        fr: "Recherche par niveau technologique",
        en: "Technological Level Search",
      },
    },
    "definitions-anchor": {
      sh: "#product_selections",
      scian: "#industry_selections",
      cti: "#tech_level_selections",
    },
    "error-help": {
      fr: "Il faut sélectionner un ou plusieurs codes dans la panneau de recherche.",
      en: "One or more codes have to be selected in the search panel.",
    },
  },
  "btn-submit": {
    label: {
      fr: "Produire rapport",
      en: "Run report",
    },
  },
};

class Form extends Component {
  constructor(props) {
    super(props);

    this._getDefaultState = this._getDefaultState.bind(this);
    this._handleComboChange = this._handleComboChange.bind(this);
    this._showReport = this._showReport.bind(this);
    this._productSelectChangeHandler =
      this._productSelectChangeHandler.bind(this);
    this._reportShowModeChangeHandler =
      this._reportShowModeChangeHandler.bind(this);
    this._getReportParameters = this._getReportParameters.bind(this);

    //validations
    this._canRunReport = this._canRunReport.bind(this);
    this._isSearchValid = this._isSearchValid.bind(this);
    this._isPeriodValid = this._isPeriodValid.bind(this);
    this._isPartnerValid = this._isPartnerValid.bind(this);
    //

    this.state = this._getDefaultState();
  }

  _getDefaultState() {
    let defaultState = {
      "trade-type": {
        value: "",
        dataSource: [],
      },
      "time-period": {
        value: "",
        dataSource: [],
      },
      "custom-years": {
        value: [],
        dataSource: [],
      },
      trader: {
        value: "",
        dataSource: [],
      },
      partner: {
        value: "",
        dataSource: [],
      },
      "partner-list": {
        value: [],
        dataSource: [],
      },
      currency: {
        value: "",
        dataSource: [],
      },
      "search-type": {
        value: "",
        label: "",
        dataSource: [],
      },
      "selected-products": [],
      "show-mode": "INDIVIDUAL",
    };

    return defaultState;
  }

  render() {
    let lienDefinition = `./hkc_Definitions_${
      this.props.lang === "en" ? "30" : "36"
    }.php`;

    return (
      <form
        className="form-horizontal texte_petit"
        onSubmit={function () {
          return false;
        }}
      >
        <section>
          <p>
            <ModalToggler
              title={LOCALES.note["modal-title"][this.props.lang]}
              content="note-quebec"
            >
              {LOCALES.note.label[this.props.lang]}
            </ModalToggler>
          </p>
          <p
            dangerouslySetInnerHTML={HTMLUtil.getHTMLTextForReact(
              LOCALES.description.label[this.props.lang]
            )}
          ></p>

          <div className="form-group">
            <label htmlFor="tradeType" className="col-sm-3 control-label">
              <span className="field-name">
                {LOCALES["trade-type"].label[this.props.lang]}
              </span>
              &nbsp;
              <ModalToggler
                title={LOCALES["trade-type"].label[this.props.lang]}
                url={`${lienDefinition} #trade_type`}
              >
                <span
                  role="button"
                  className="glyphicon glyphicon-question-sign"
                ></span>
              </ModalToggler>
            </label>
            <div className="col-sm-9">
              <Dropdown
                id="trade-type"
                name="reportType"
                lang={this.props.lang}
                onChange={this._handleComboChange}
                value={this.state["trade-type"].value}
                dataSource={this.state["trade-type"].dataSource}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="time-period" className="col-sm-3 control-label">
              <span className="field-name">
                {LOCALES["time-period"].label[this.props.lang]}
              </span>
              &nbsp;
              <ModalToggler
                title={LOCALES["time-period"].label[this.props.lang]}
                url={`${lienDefinition} #time_period`}
              >
                <span
                  role="button"
                  className="glyphicon glyphicon-question-sign"
                ></span>
              </ModalToggler>
            </label>
            <div className="col-sm-9">
              <Dropdown
                id="time-period"
                name="timePeriod"
                lang={this.props.lang}
                onChange={this._handleComboChange}
                value={this.state["time-period"].value}
                dataSource={this.state["time-period"].dataSource}
              />
            </div>
          </div>
          {this._getCustomYears()}
          <div className="form-group">
            <label htmlFor="trader" className="col-sm-3 control-label">
              <span className="field-name">
                {LOCALES["trader"].label[this.props.lang]}
              </span>
              &nbsp;
              <a role="button" className="invisible">
                <span
                  role="button"
                  className="glyphicon glyphicon-question-sign"
                ></span>
              </a>
            </label>
            <div className="col-sm-9">
              <Dropdown
                id="trader"
                name="trader"
                lang={this.props.lang}
                onChange={this._handleComboChange}
                value={this.state["trader"].value}
                dataSource={this.state["trader"].dataSource}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="partner" className="col-sm-3 control-label">
              <span className="field-name">
                {LOCALES["partner"].label[this.props.lang]}
              </span>
              &nbsp;
              <ModalToggler
                title={LOCALES["partner"].label[this.props.lang]}
                url={`${lienDefinition} #trading_partner`}
              >
                <span
                  role="button"
                  className="glyphicon glyphicon-question-sign"
                ></span>
              </ModalToggler>
            </label>
            <div className="col-sm-9">
              <Dropdown
                id="partner"
                name="partner"
                lang={this.props.lang}
                onChange={this._handleComboChange}
                value={this.state["partner"].value}
                dataSource={this.state["partner"].dataSource}
              />
            </div>
          </div>
          {this._getPartnerList()}
          <div className="form-group">
            <label htmlFor="currency" className="col-sm-3 control-label">
              <span className="field-name">
                {LOCALES["currency"].label[this.props.lang]}
              </span>
              &nbsp;
              <ModalToggler
                title={LOCALES["currency"].label[this.props.lang]}
                url={`${lienDefinition} #value_in`}
              >
                <span
                  role="button"
                  className="glyphicon glyphicon-question-sign"
                ></span>
              </ModalToggler>
            </label>
            <div className="col-sm-9">
              <Dropdown
                id="currency"
                name="currency"
                lang={this.props.lang}
                onChange={this._handleComboChange}
                value={this.state["currency"].value}
                dataSource={this.state["currency"].dataSource}
              />
            </div>
          </div>

          <div
            className={`form-group ${
              !this._isSearchValid() ? "has-warning" : ""
            }`}
          >
            <label htmlFor="search-type" className="col-sm-3 control-label">
              <span className="field-name">
                {LOCALES["search-type"].label[this.props.page][this.props.lang]}
              </span>
              &nbsp;
              <ModalToggler
                title={
                  LOCALES["search-type"].label[this.props.page][this.props.lang]
                }
                url={`${lienDefinition} ${
                  LOCALES["search-type"]["definitions-anchor"][this.props.page]
                }`}
              >
                <span
                  role="button"
                  className="glyphicon glyphicon-question-sign"
                ></span>
              </ModalToggler>
            </label>
            <div className="col-sm-9">
              <Dropdown
                id="search-type"
                name="searchType"
                lang={this.props.lang}
                onChange={this._handleComboChange}
                value={this.state["search-type"].value}
                dataSource={this.state["search-type"].dataSource}
              />
              {!this._isSearchValid() ? (
                <span id="searchType-help" className="help-block small">
                  {LOCALES["search-type"]["error-help"][this.props.lang]}
                </span>
              ) : null}
            </div>
          </div>
          {this._getSearchPanel()}
          <footer className="panel-footer">
            <input
              type="button"
              className="btn btn-primary"
              value={LOCALES["btn-submit"].label[this.props.lang]}
              disabled={!this._canRunReport()}
              onClick={this._showReport}
            />
          </footer>
        </section>
      </form>
    );
  }

  componentDidMount() {
    this._updateAllCombo();
  }

  componentDidUpdate(prevProps) {
    //Reinitialiser l'état lorsque l'on change de langue
    if (prevProps.lang !== this.props.lang) {
      this.setState(this._getDefaultState(), () => this._updateAllCombo());
    }
  }

  _updateAllCombo() {
    this._fetchTradeTypes();
    this._fetchTimePeriod();
    this._fetchCustomYears();
    this._fetchTrader();
    this._fetchCurrency();
  }

  _canRunReport() {
    if (
      this._isSearchValid() &&
      this._isPeriodValid() &&
      this._isPartnerValid()
    ) {
      return true;
    } else {
      return false;
    }
  }

  //Partenaire Custom (PAYS, ETAT, GROUPE) SANS Partenaire selectionné
  _isPartnerValid() {
    let valid = true;

    let partner = this.state["partner"].value.toLowerCase();

    if (
      (partner === "sp" ||
        partner === "re" ||
        partner === "gpc" ||
        partner === "reur") &&
      this.state["partner-list"].value.length === 0
    ) {
      valid = false;
    }

    return valid;
  }

  //Temp = custom SANS aucune année choisie
  _isPeriodValid() {
    let valid = true;

    let timePeriod = this.state["time-period"].value.toLowerCase();

    if (
      timePeriod.indexOf("custom years") !== -1 &&
      this.state["custom-years"].value.length === 0
    ) {
      valid = false;
    }

    return valid;
  }

  //Code de produit custom SANS produit sélectionné
  _isSearchValid() {
    let valid = true;

    let typeSearch = this.state["search-type"].value.toLowerCase();

    if (
      (typeSearch === "bl" || typeSearch === "ks" || typeSearch === "cs") &&
      this.state["selected-products"].length === 0
    ) {
      valid = false;
    }

    return valid;
  }

  /**
   * Mise à jour de la valeur dans l'état pour un composant précis lors du onChange
   * @param {*} id    Id de l'élément qui a généré le changement de valeur
   * @param {*} value Nouvelle(s) valeur(s) sélectionnée(s)
   * @param {*} label Nouveau(x) libellé(s) sélectionné(s)
   */
  _handleComboChange(elem, value, label) {
    let id = elem.id;

    this.setState(
      (prevState) => {
        let newState = {};
        //Affecter la nouvelle valeur pour le champ de formulaire qui a changée
        newState[id] = Object.assign({}, prevState[id], { value, label });

        //Si c'est la boite "time-period" qui a changée, on réinitialise les valeurs pour la boite "custom-years"
        if (id === "time-period") {
          newState["custom-years"] = Object.assign(
            {},
            prevState["custom-years"],
            { value: [] }
          );
        }
        //Si c'est la boite "partner" qui a changée, on réinitialise les valeurs et le dataSource pour la boite "partner-list"
        else if (id === "partner") {
          newState["partner-list"] = Object.assign(
            {},
            prevState["partner-list"],
            { dataSource: [], value: [] }
          );
        }
        //Si la boite du type de recherche à été changée, on réinitialise l'état de 'show-mode' (individual ou grouped)
        else if (id === "search-type") {
          newState["show-mode"] = "";
        }
        return newState;
      },
      () => {
        //Si c'est la boite "tradeType" qui a changée, on fetch les donnees pour "partner" et "searchType" selon la valeur de "trade-type"
        if (id === "trade-type") {
          this._fetchPartner(value);
          this._fetchSearchType(value);
        }
        //Si c'est la boîte "partner" qui a changée ET que sa valeur correspond à SP, RE, GPC ou REUR,
        //on fetch les donnees pour "partner-list"
        else if (
          id === "partner" &&
          (value.toUpperCase() === "SP" ||
            value.toUpperCase() === "RE" ||
            value.toUpperCase() === "GPC" ||
            value.toUpperCase() === "REUR")
        ) {
          this._fetchPartnerList(value);
        }
      }
    );
  }

  _getCustomYears() {
    var elem = "";
    if (
      this.state["time-period"].value.toLowerCase().indexOf("custom") !== -1
    ) {
      elem = (
        <div
          className={`form-group ${!this._isPeriodValid() ? "has-error" : ""}`}
        >
          <label htmlFor="custom-years" className="col-sm-3 control-label">
            <span className="field-name">
              {LOCALES["custom-years"].label[this.props.lang]}
            </span>
          </label>
          <div className="col-sm-9">
            <Dropdown
              id="custom-years"
              name="customYears[]"
              lang={this.props.lang}
              isMulti={true}
              onChange={this._handleComboChange}
              value={this.state["custom-years"].value}
              dataSource={this.state["custom-years"].dataSource}
            />
          </div>
        </div>
      );
    }
    return elem;
  }

  _getPartnerList() {
    var elem = "";

    if (this.state["partner-list"].dataSource.length > 0) {
      elem = (
        <div
          className={`form-group ${!this._isPartnerValid() ? "has-error" : ""}`}
        >
          <label htmlFor="partner-list" className="col-sm-3 control-label">
            <span className="field-name">
              {
                LOCALES["partner-list"].label[
                  this.state.partner.value.toLowerCase()
                ][this.props.lang]
              }
            </span>
          </label>
          <div className="col-sm-9">
            <Dropdown
              id="partner-list"
              name="partnerList[]"
              lang={this.props.lang}
              size={10}
              isMulti={true}
              onChange={this._handleComboChange}
              value={this.state["partner-list"].value}
              dataSource={this.state["partner-list"].dataSource}
            />
          </div>
        </div>
      );
    }

    return elem;
  }

  _getSearchPanel() {
    let searchType = this.state["search-type"].value.toLowerCase();

    if (searchType === "ks" || searchType === "cs" || searchType === "bl") {
      return (
        <SearchPanel
          type={searchType}
          lang={this.props.lang}
          page={this.props.page}
          onSelectChange={this._productSelectChangeHandler}
          onShowModeChange={this._reportShowModeChangeHandler}
        />
      );
    }
  }

  _productSelectChangeHandler(selectedProducts) {
    this.setState({ "selected-products": selectedProducts });
  }

  _reportShowModeChangeHandler(value) {
    this.setState((prevState) => {
      return { "show-mode": value };
    });
  }

  _showReport() {
    if (this._canRunReport()) {
      this._openReport();
    }
  }
  /**
   * LISTE DES APPELS D'API ASYNC
   */
  /**
   * Chercher les données pour la boite deroulante tradeType
   */
  _fetchTradeTypes() {
    fetch(
      `${PREFIX_API}hkc_api_web.p_retrn_echange?p_lang=${this.props.lang}&p_comer=${this.props.page}`
    )
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 400) {
          return resp.text();
        } else {
          return "";
        }
      })
      .then((data) => {
        let dataParsed = CSVUtils.csvToJSON(data);

        this.setState(
          (prevState) => {
            let tradeTypeState = Object.assign(prevState["trade-type"], {
              dataSource: dataParsed,
              value: dataParsed[0].value,
            });
            return { "trade-type": tradeTypeState };
          },
          () => {
            this._fetchPartner(dataParsed[0].value);
            this._fetchSearchType(dataParsed[0].value);
          }
        );
      })
      .catch((error) => {
        console.error("Problèmes: fetchTradeTypes", error);
      });
  }

  /**
   * Chercher les données pour la boite deroulante timePeriod
   */
  _fetchTimePeriod() {
    fetch(
      `${PREFIX_API}hkc_api_web.p_retrn_period?p_lang=${this.props.lang}&p_comer=${this.props.page}`
    )
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 400) {
          return resp.text();
        } else {
          return "";
        }
      })
      .then((data) => {
        let dataParsed = CSVUtils.csvToJSON(data);

        this.setState((prevState) => {
          let timeState = Object.assign(prevState["time-period"], {
            dataSource: dataParsed,
            value: dataParsed[0].value,
          });
          return { "time-period": timeState };
        });
      })
      .catch((error) => {
        console.error("Problèmes: fetchTimePeriod", error);
      });
  }

  /**
   * Chercher les années possibles pour la boite multi custom-years
   */
  _fetchCustomYears() {
    fetch(
      `${PREFIX_API}hkc_api_web.p_retrn_annee_spec?p_lang=${this.props.lang}&p_comer=${this.props.page}`
    )
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 400) {
          return resp.text();
        } else {
          return "";
        }
      })
      .then((data) => {
        let dataParsed = CSVUtils.csvToJSON(data);

        this.setState((prevState) => {
          let customYearsState = Object.assign(prevState["custom-years"], {
            dataSource: dataParsed,
            value: [],
          });
          return { "custom-years": customYearsState };
        });
      })
      .catch((error) => {
        console.error("Problèmes: fetchCustomYears", error);
      });
  }
  /**
   * Chercher les données pour la boite deroulante trader
   */
  _fetchTrader() {
    fetch(
      `${PREFIX_API}hkc_api_web.p_retrn_comerce?p_lang=${this.props.lang}&p_comer=${this.props.page}`
    )
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 400) {
          return resp.text();
        } else {
          return "";
        }
      })
      .then((data) => {
        let dataParsed = CSVUtils.csvToJSON(data);

        this.setState((prevState) => {
          let traderState = Object.assign(prevState["trader"], {
            dataSource: dataParsed,
            value: dataParsed[0].value,
          });
          return { trader: traderState };
        });
      })
      .catch((error) => {
        console.error("Problèmes: fetchTrader", error);
      });
  }

  /**
   * Chercher les données pour la boite deroulante trader
   */
  _fetchPartner(type) {
    fetch(
      `${PREFIX_API}hkc_api_web.p_retrn_partnr?p_lang=${this.props.lang}&p_comer=${this.props.page}&p_type=${type}`
    )
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 400) {
          return resp.text();
        } else {
          return "";
        }
      })
      .then((data) => {
        let dataParsed = CSVUtils.csvToJSON(data);

        this.setState(
          (prevState) => {
            let partnerListState = Object.assign(prevState["partner-list"], {
              dataSource: [],
              value: [],
            });
            let partnerState = Object.assign(prevState["partner"], {
              dataSource: dataParsed,
              value: dataParsed[0].value,
            });
            return { partner: partnerState, "partner-list": partnerListState };
          },
          () => {
            let partnerValue = this.state.partner.value;
            if (
              partnerValue.toUpperCase() === "SP" ||
              partnerValue.toUpperCase() === "RE" ||
              partnerValue.toUpperCase() === "GPC" ||
              partnerValue.toUpperCase() === "REUR"
            ) {
              this._fetchPartnerList(dataParsed[0].value);
            }
          }
        );
      })
      .catch((error) => {
        console.error("Problèmes: fetchPartner", error);
      });
  }

  /**
   * Chercher les données pour la boite deroulante des pays/regions
   */
  _fetchPartnerList(type) {
    fetch(
      `${PREFIX_API}hkc_api_web.p_retrn_partnr_list?p_lang=${this.props.lang}&p_comer=${this.props.page}&p_type_list=${type}`
    )
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 400) {
          return resp.text();
        } else {
          return "";
        }
      })
      .then((data) => {
        let dataParsed = CSVUtils.csvToJSON(data);

        this.setState((prevState) => {
          let partnerListState = Object.assign(prevState["partner-list"], {
            dataSource: dataParsed,
            value: [],
          });
          return { "partner-list": partnerListState };
        });
      })
      .catch((error) => {
        console.error("Problèmes: fetchPartnerList", error);
      });
  }

  /**
   * Chercher les données pour la boite deroulante "Valeur en"
   */
  _fetchCurrency() {
    fetch(
      `${PREFIX_API}hkc_api_web.p_retrn_valeur?p_lang=${this.props.lang}&p_comer=${this.props.page}`
    )
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 400) {
          return resp.text();
        } else {
          return "";
        }
      })
      .then((data) => {
        let dataParsed = CSVUtils.csvToJSON(data);

        this.setState((prevState) => {
          let currencyState = Object.assign(prevState["currency"], {
            dataSource: dataParsed,
            value: dataParsed[0].value,
          });
          return { currency: currencyState };
        });
      })
      .catch((error) => {
        console.error("Problèmes: fetchCurrency", error);
      });
  }

  /**
   * Chercher les données pour la boite deroulante "Recherche par..."
   */
  _fetchSearchType(type) {
    fetch(
      `${PREFIX_API}hkc_api_web.p_retrn_produit?p_lang=${this.props.lang}&p_comer=${this.props.page}&p_type=${type}`
    )
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 400) {
          return resp.text();
        } else {
          return "";
        }
      })
      .then((data) => {
        let dataParsed = CSVUtils.csvToJSON(data);

        this.setState((prevState) => {
          let searchTypeState = Object.assign(prevState["search-type"], {
            dataSource: dataParsed,
            value: dataParsed[0].value,
          });
          return { "search-type": searchTypeState };
        });
      })
      .catch((error) => {
        console.error("Problèmes: fetchSearchType", error);
      });
  }

  _getReportParameters() {
    let countryList = "";
    let productList = "";
    let grouped = "";
    let productType = "";
    let searchType = this.state["search-type"].value.toLowerCase();

    //Liste des codes s'il y a lieu
    if (searchType === "ks" || searchType === "cs" || searchType === "bl") {
      productList = this.state["selected-products"].join("|");
    }

    //Liste de selections de regions/pays
    if (this.state["partner-list"].value.length === 0) {
      countryList = this.state["partner"].value;
    } else {
      countryList = this.state["partner-list"].value.join("|");
    }

    //Mode d'affichage du rapport SI on a fait une selection de produits
    if (this.state["selected-products"].length > 0) {
      //Si c'est une recherche spécifique, on prend le
      if (searchType === "ks" || searchType === "cs" || searchType === "bl") {
        grouped = this.state["show-mode"] || "INDIVIDUAL";
      } else {
        grouped = "";
      }
    }

    //Type de produit
    switch (this.props.page) {
      case "sh":
        productType = "HS6";
        break;
      case "scian":
        productType = "NAICS";
        break;
      case "cti":
        productType = "SIC";
        break;
      default:
        productType = "";
    }

    //google analitics 4
    const pagetitreValue = document.querySelector(
      "div#contenu_centre >h1"
    ).innerHTML;
    const typeValue = this.state["trade-type"].dataSource.find(
      ({ value }) => value === this.state["trade-type"].value
    )?.label;
    const periodeValue = this.state["time-period"].dataSource.find(
      ({ value }) => value === this.state["time-period"].value
    )?.label;
    const commercantValue = this.state["trader"].dataSource.find(
      ({ value }) => value === this.state["trader"].value
    )?.label;
    const partenaireValue = this.state["partner"].dataSource.find(
      ({ value }) => value === this.state["partner"].value
    )?.label;
    const valeurValue = this.state["currency"].dataSource.find(
      ({ value }) => value === this.state["currency"].value
    )?.label;
    const produitValue = this.state["search-type"].dataSource.find(
      ({ value }) => value === this.state["search-type"].value
    )?.label;

    const ga4Event = {
      page_title: pagetitreValue,
      type_echange: typeValue,
      periode: periodeValue,
      commercant: commercantValue,
      partenaire: partenaireValue,
      valeur: valeurValue,
    };

    //Type de produit pour ga4
    switch (this.props.page) {
      case "sh":
        ReactGA.event("rapport", { ...ga4Event, produit: produitValue });
        break;
      case "scian":
        ReactGA.event("rapport", { ...ga4Event, industrie: produitValue });
        break;
      case "cti":
        ReactGA.event("rapport", {
          ...ga4Event,
          niveau_technologique: produitValue,
        });
        break;
    }

    return `cacheTime=${Date.now()}&lang=${
      this.props.lang === "en" ? 30 : 36
    }&productType=${productType}&reportType=${
      this.state["trade-type"].value
    }&timePeriod=${this.state["time-period"].value}&periodString=${this.state[
      "custom-years"
    ].value.join("|")}&naArea=${
      this.state["trader"].value
    }&countryList[]=${countryList}&currency=${
      this.state["currency"].value
    }&searchType=${
      this.state["search-type"].value
    }&hSelectedCodes=${productList}&grouped=${grouped}&runReport.x=Produire rapport&toFromCountry=CDN`;
  }

  _openReport() {
    let prefixURL =
      process.env.NODE_ENV === "development"
        ? "https://validation-siteweb-isq.isq-prod.stat/commerce-international"
        : ".";
    window.open(
      `${prefixURL}/hkc-2018.php?${this._getReportParameters()}`,
      "_blank"
    );
  }
}

export default Form;
